import { useEffect } from 'react';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { SceneType } from '@/store/slices/scene';
import * as Apis from '@/apis/login';
import Utils from '@/utils';
import { useDispatch } from '@/store';
import { setRTSParams } from '@/store/slices/rts';
import { setSTSParams } from '@/store/slices/sts';
import { login, setUserVisibility } from '@/store/slices/user';
import { VerifiedStatus } from './types';
import { BASENAME } from '@/config';
import TeaClient from '@/core/rtc/TeaClient';

interface IHideUser {
  name: string | null;
  roomId: string | null;
  visibility: string | null;
  role: string | null;
}

interface IHideUserAuth {
  hideUser: IHideUser;
  scene?: SceneType;
  onVerify: (status: VerifiedStatus) => void;
}

const useHideUserAuth = (props: IHideUserAuth) => {
  const { scene, hideUser, onVerify } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (hideUser.visibility === 'false' && scene) {
      const freeLogin = async () => {
        const res = await Apis.freeLoginApi({
          device_id: Utils.getDeviceId()!,
          user_name: hideUser.name || 'hideUser',
        });

        if (res.code !== 200) {
          message.error(res.message);
          TeaClient.reportUserLogin(false, JSON.stringify(res));
          return;
        }

        const freeUser = res.response;
        const rtsRes = await Apis.getRTSParams({
          login_token: freeUser.login_token,
        });

        if (rtsRes.code !== 200) {
          message.error(rtsRes.message);
          TeaClient.reportUserLogin(false, JSON.stringify(res));
          return;
        }
        TeaClient.setLoginInfo(freeUser.user_name, freeUser.user_id, Utils.getDeviceId() || '');
        TeaClient.setSceneType(scene);
        TeaClient.reportUserLogin(true);
        dispatch(login(freeUser));

        dispatch(setRTSParams(rtsRes.response));

        dispatch(setSTSParams({login_token: freeUser.login_token!}));
        
        dispatch(setUserVisibility(false));
        onVerify(VerifiedStatus.Pass);
        const naviPath = location.pathname.replace(BASENAME, '');
        navigate(`${naviPath}${location.search}`);
      };

      onVerify(VerifiedStatus.Waiting);

      freeLogin();
    }
  }, [hideUser, scene]);
};

export default useHideUserAuth;
